export default "__VITE_ASSET__hDuV_zei__"